import Index from "../components/Calendar/Index.jsx";

const BigCalendar = () => {
    return <Index />;
};

export default BigCalendar;
